import React from "react";
import { convertShipmentUnitFromMetricToImperial, shipmentUnitUoMOptions } from "src/helpers";
import { ShipmentUnitsColumnHeaderImperial, ShipmentUnitsColumnHeaderMetric } from "src/enums";
import { ShipmentUnit, TableColumn, UoM } from "src/types";
import { OptionSelector } from "src/components/ui/inputs";
import { Table } from "src/components";

interface ShipmentUnitTableProps {
  shipmentsUnits: ShipmentUnit[];
  shipmentUnitsUoM: string;
  setShipmentUnitsUoM: (uom: UoM) => void;
}

const ShipmentUnitTable: React.FC<ShipmentUnitTableProps> = ({
  shipmentsUnits,
  shipmentUnitsUoM,
  setShipmentUnitsUoM
}) => {
  const shipmentUnitHeaderEnum =
    shipmentUnitsUoM === "Imperial" ? ShipmentUnitsColumnHeaderImperial : ShipmentUnitsColumnHeaderMetric;

  const convertedUnits =
    shipmentUnitsUoM === "Imperial" ? shipmentsUnits.map(convertShipmentUnitFromMetricToImperial) : shipmentsUnits;

  const columns: TableColumn<ShipmentUnitsColumnHeaderImperial | ShipmentUnitsColumnHeaderMetric, ShipmentUnit>[] = [
    {
      header: shipmentUnitHeaderEnum.TYPE,
      column: (row) => <span className="text-sm font-medium text-secondary-900">{row.type}</span>,
      styles: { minWidth: "140px" }
    },
    {
      header: shipmentUnitHeaderEnum.QUANTITY,
      column: (row) => <span className="text-sm font-semibold text-secondary-900">{row.quantity}</span>,
      styles: { minWidth: "120px", width: "120px", textAlign: "center" }
    },
    {
      header: shipmentUnitHeaderEnum.WEIGHT,
      column: (row) => <span className="text-sm text-secondary-800">{row.weight}</span>,
      styles: { minWidth: "120px", width: "120px", textAlign: "center" }
    },
    {
      header: shipmentUnitHeaderEnum.LENGTH,
      column: (row) => <span className="text-sm text-secondary-800">{row.length}</span>,
      styles: { minWidth: "120px", width: "120px", textAlign: "center" }
    },
    {
      header: shipmentUnitHeaderEnum.WIDTH,
      column: (row) => <span className="text-sm text-secondary-800">{row.width}</span>,
      styles: { minWidth: "120px", width: "120px", textAlign: "center" }
    },
    {
      header: shipmentUnitHeaderEnum.HEIGHT,
      column: (row) => <span className="text-sm text-secondary-800">{row.height}</span>,
      styles: { minWidth: "120px", width: "120px", textAlign: "center" }
    }
  ];

  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-secondary-600">
          Showing shipment units in <span className="font-semibold text-secondary-900">{shipmentUnitsUoM}</span>.
        </p>
        <OptionSelector
          options={shipmentUnitUoMOptions}
          onSelect={(option) => setShipmentUnitsUoM((option as UoM) || "Metric")}
          value={shipmentUnitsUoM}
        />
      </div>
      <Table<ShipmentUnitsColumnHeaderImperial | ShipmentUnitsColumnHeaderMetric, ShipmentUnit>
        data={convertedUnits}
        columns={columns}
      />
    </div>
  );
};

export { ShipmentUnitTable };
